import { css } from "@emotion/react";
import React from "react";
import { CellContext } from "@tanstack/react-table";

import { useTimeFormatters } from "@phoenix/hooks/useTimeFormatters";
import { isStringOrNullOrUndefined } from "@phoenix/typeUtils";

export const DEFAULT_FORMAT: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
};

/**
 * A table cell that nicely formats a timestamp using monospace typography and subtle secondary coloring.
 */
export function TimestampCell<TData extends object, TValue>({
  getValue,
}: CellContext<TData, TValue>) {
  const { fullTimeFormatter } = useTimeFormatters();
  const value = getValue();
  if (!isStringOrNullOrUndefined(value)) {
    throw new Error(
      "TimestampCell only supports string, null, or undefined values."
    );
  }
  const timestamp = value != null ? fullTimeFormatter(new Date(value)) : "--";
  return (
    <time
      title={value != null ? String(value) : ""}
      css={css`
        font-family: 'Century Gothic', CenturyGothic, AppleGothic, sans-serif;
        font-weight: 400;
        font-size: 12px;
        color: #64748b;
        white-space: nowrap;
        .theme--dark & {
          color: #94a3b8;
        }
      `}
    >
      {timestamp}
    </time>
  );
}
